// app/store-initializer.tsx
'use client';

import type { AuthenticatedUserResponse } from '@govinity/validation';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

interface StoreInitializerProps {
  user: AuthenticatedUserResponse | null;
}

export function StoreInitializer({ user }: StoreInitializerProps) {
  const login = useAuthStore((state) => state.login);

  useEffect(() => {
    if (user) {
      login(user);
    }
  }, [login, user]);

  return null;
}
